// src/components/HandwritingReport.jsx
import React from "react";

const Report = ({ result, timestamp }) => {
  if (!result) return null;

  // Determine risk class
  let riskClass = "low";
  if (result.dysgraphia_risk?.includes("High")) riskClass = "high";
  else if (result.dysgraphia_risk?.includes("Moderate")) riskClass = "moderate";

  const statKeys = [
    { label: "Char Error Rate", key: "char_error_rate" },
    { label: "Word Error Rate", key: "word_error_rate" },
    { label: "Substitutions", key: "substitutions" },
    { label: "Insertions", key: "insertions" },
    { label: "Deletions", key: "deletions" },
    { label: "Reversed Letters", key: "reversed_letters" },
  ];

  return (
    <div className="w-full bg-white p-8 rounded-xl shadow-lg mt-8 print:p-0 print:shadow-none">
      <div className="text-center border-b-2 border-blue-500 pb-4 mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Dysgraphia Indicator Report</h1>
        <div className="text-gray-500 text-sm mt-1">{timestamp}</div>
      </div>

      {/* Risk Section */}
      <div className={`mb-6 p-4 rounded-lg border-l-6 ${
        riskClass === "high" ? "border-red-600 bg-red-50" :
        riskClass === "moderate" ? "border-yellow-500 bg-yellow-50" :
        "border-green-500 bg-green-50"
      }`}>
        <h2 className="text-lg font-semibold text-blue-700 mb-2">Screening Result</h2>
        <p className={`font-bold text-center ${
          riskClass === "high" ? "text-red-700" :
          riskClass === "moderate" ? "text-yellow-700" :
          "text-green-700"
        }`}>{result.dysgraphia_risk}</p>
      </div>

      {/* Sample details */}
      <div className="mb-6 p-4 bg-gray-50 rounded-lg">
        <h2 className="text-lg font-semibold text-blue-700 mb-2">Submitted Sample Details</h2>
        <strong>Reference Sentence:</strong>
        <p className="font-mono bg-white p-2 rounded mt-1">{result.expected}</p>
        <strong className="mt-3 block">Recognized (OCR) Sentence:</strong>
        <p className="font-mono bg-white p-2 rounded mt-1">{result.ocr_output}</p>
      </div>

      {/* Metrics */}
      <div className="mb-6 p-4 bg-gray-50 rounded-lg">
        <h2 className="text-lg font-semibold text-blue-700 mb-2">Handwriting Analysis Metrics</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {statKeys.map((stat) => (
            <div key={stat.key} className="bg-white p-3 rounded shadow-sm text-center">
              <span className="block text-gray-500 text-sm">{stat.label}</span>
              <span className="block font-bold text-gray-800">{result[stat.key]}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Disclaimer */}
      <div className="text-gray-500 text-xs mt-4 border-t pt-2">
        <strong>Disclaimer:</strong> This report is generated by an automated tool and is not a substitute for a professional diagnosis. Use it for informational purposes only. Consult a qualified specialist for a complete evaluation.
      </div>
    </div>
  );
};

export default Report;
